import clsx from 'clsx'
import { Icon, Typography } from 'components'
import { BoxContentDeliveryProps, Icons, TypographyTypes } from 'interfaces'
import React from 'react'

export const BoxContentDelivery: React.FC<BoxContentDeliveryProps> = ({
	title,
	onClick,
	active = false,
	typeFunction = 'Location'
}): JSX.Element => {
	const iconElement = (): JSX.Element => (
		<Icon
			src={active ? Icons.task : Icons.add}
			className="w-[24px] h-[24px] mx-2"
		/>
	)

	return (
		<button
			type="button"
			onClick={onClick}
			className={clsx(
				'flex items-center w-full border-b-2 py-[11px] rounded-[4px]',
				active
					? 'bg-blue-primary bg-opacity-25 border-blue-primary'
					: 'border-gray-11'
			)}
		>
			{typeFunction === 'Content' && iconElement()}
			<Typography
				title={title}
				className={clsx('text-gray-9 flex-grow text-left')}
				type={TypographyTypes.span}
				fontLeading="15/18"
			/>
			{typeFunction !== 'Content' && iconElement()}
		</button>
	)
}
